import { newService } from './service';

/**
 *
 *
 * LOAD APP
 *
 *
 */

if (process.env.NODE_ENV === 'development') {
  /**
   * Only for local development
   * We need to simulate HOST functionality and run our service
   */
  (async () => {
    const token = process.env.REACT_APP_TOKEN;
    const { initMockShell } = await import('./services/MockShell');
    // Mock HOST
    initMockShell(newService.name, {
      'base-url': '/casino/pm-casino',
      'render-container': '#pm-casino',
      language: 'en',
      brand: process.env.REACT_APP_BRAND || 'COM',
      channel: 'MOBILE_WEB',
      'proxy-prefix': `/service-discovery/service/${newService.name}`,
      'ams:segments': [],
      'cross-domain-click-stream-id': 'test',
      'user-data': {
        number: '123456',
        firstName: 'player',
        middleName: '',
        lastName: 'test',
        dateOfBirthday: '1992-11-01T00:00:00Z',
        country: {
          id: 533,
          iso2: 'AW',
          iso3: 'ABW',
          name: 'Aruba',
          telephoneDialingPrefix: '297',
        },
        city: '',
        email: 'tes***@betlab',
        phone: '',
        currency: { id: 3, name: 'USD', isRestricted: false, isCupis: false },
        balances: { total: 1000 },
        currencyRate: 1,
        restOfSum: 186.6,
        restOfNCalc: 0,
        restOfNPay: 0,
        isBlocked: false,
        isPokerPlayer: false,
        status: 0,
        isEmailConfirmed: false,
        lastIp: '10.96.0.183',
        bonus4Express: { step: 0, minCoef: 0, minCount: 0, maxCount: 0 },
        address1: '',
        address2: '',
        isDepositDisabled: false,
        gravitecAlias: '493733930',
        isWithdrawalDisabledCy: false,
        isShortRegistration: false,
        isShortRegistrationCompleted: false,
        isPhoneConfirmed: false,
        isTwoFactorAuthEnabled: false,
        paymentsInfo: '',
      },

      'user-token': token,
      platform: 'natasha',
    });

    window.newService = newService;

    // aba-mock-host is only for development.
    // It should be required dynamically to prevent useless css files import in production build
    require('aba-mock-host').render({
      shellId: 'shell',
      rootId: 'pm-casino',
      withHeaderProjectPicker: false,
    });

    newService.start();
  })();
} else {
  newService.start();
}
